// extracted by mini-css-extract-plugin
module.exports = {"newsletterEmailWrap":"my-newsletter-subscription_newsletterEmailWrap__d1MXJ","newsletterInputWrap":"my-newsletter-subscription_newsletterInputWrap__d_jlS"};